// app/src/contexts/ScaleContextMobile.tsx

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ScaleContextProps {
	scaleMobile: number;
}

const ScaleContextMobile = createContext<ScaleContextProps>({ scaleMobile: 1 });

export const ScaleProviderMobile: React.FC<{ children: ReactNode }> = ({ children }) => {
	const baseWidth = 390; // Largeur de base en pixels
	const [scaleMobile, setScaleMobile] = useState(1);
	
	useEffect(() => {
		const handleResize = () => {
			const viewportWidth = window.innerWidth;
			const newScale = viewportWidth / baseWidth;
			
			// Définir des limites pour le facteur de mise à l'échelle
			const minScale = 0.5; // Minimum 50%
			const maxScale = 1.5; // Maximum 150%
			const clampedScale = Math.max(minScale, Math.min(newScale, maxScale));
			
			setScaleMobile(clampedScale);
		};
		
		// Calcul initial du facteur de mise à l'échelle
		handleResize();
		
		// Ajouter l'écouteur d'événements pour le redimensionnement de la fenêtre
		window.addEventListener('resize', handleResize);
		
		// Nettoyage de l'écouteur d'événements
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	
	return (
		<ScaleContextMobile.Provider value={{ scaleMobile: scaleMobile }}>
			{children}
		</ScaleContextMobile.Provider>
	);
};

export const useScaleMobile = () => useContext(ScaleContextMobile);
